export const FETCHING = "FETCHING";
export const FETCHED = "FETCHED";

// Setting
export const FETCHED_SETTING = "FETCHED_SETTING";
export const UPDATE_REGISTER_TEXT_SETTING = "UPDATE_REGISTER_TEXT_SETTING";
export const FETCHED_SETTING_GOOGLE_FLAG = "FETCHED_SETTING_GOOGLE_FLAG";
export const FETCHED_SETTING_FACEBOOK_FLAG = "FETCHED_SETTING_FACEBOOK_FLAG";
export const FETCHED_SETTING_TWITTER_FLAG = "FETCHED_SETTING_TWITTER_FLAG";
export const FETCHED_SETTING_LINKEDIN_FLAG = "FETCHED_SETTING_LINKEDIN_FLAG";
export const FETCHED_SETTING_AMAZON_FLAG = "FETCHED_SETTING_AMAZON_FLAG";
export const FETCH_DESIGN = "FETCH_DESIGN";
export const UPDATE_DESIGN = "UPDATE_DESIGN";
export const FETCHED_CUSTOME_DESIGN = "FETCHED_CUSTOME_DESIGN";
export const UPDATED_CUSTOME_DESIGN = "UPDATED_CUSTOME_DESIGN";












